module.exports = __webpack_public_path__ + "img/icon_saomiao.186eeb59.png";